import React from 'react';
import { Box } from '@mui/material';
import MDTypography from 'components/MDTypography';
import { ListItemWrap, StatusDot } from '../dashboardStyled';

const DashboardAssets = (props) => {
  const { myProfile } = props;
  const assets = myProfile?.assignedAssets;

  if (!assets || assets?.length === 0) {
    return null;
  }

  return (
    <>
      {assets?.map((item, index) => {
        const { assetTag, serial, type } = item;
        return (
          <ListItemWrap key={index} py={0.5}>
            <StatusDot bgcolor="#adb5bd" />
            <Box>
              <MDTypography variant="button" fontWeight="bold" display="block">
                {type.val}
              </MDTypography>
              <MDTypography variant="caption" color="text">
                Tag: {assetTag} · Serial: {serial}
              </MDTypography>
            </Box>
          </ListItemWrap>
        );
      })}
    </>
  );
};

export default DashboardAssets;
